import { customGaEvent, GA_EVENTS } from '../utils/ga';
import mapInterface from './mapInterface';

/**
 * Creates an instance of LayerControls.
 * @param { publicTour === bool, currentTour === Object }, defaults to {}
 */

class LayerControls {
  constructor({ publicTour, currentTour } = {}) {
    this.publicTour = publicTour;
    this.currentTour = currentTour;
    this.layerBtn = null;
    this.tooltip = null;
  }

  onAdd(map) {
    this.container = document.createElement('div');
    this.container.innerHTML = `<button class="mapboxgl-ctrl-icon mapboxgl-ctrl-layer"><i class="material-icons">layers</i></button>`;
    this.container.addEventListener('click', () => this.toggleStyle(map));
    this.container.addEventListener('mouseenter', () => this.mouseIn());
    this.container.addEventListener('mouseleave', () => this.mouseOut());
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    return this.container;
  }

  mouseIn() {
    this.layerBtn = document.querySelector('.mapboxgl-ctrl-layer');
    this.tooltip = document.createElement('span');
    this.tooltip.className = 'tooltip map-layers';
    this.tooltip.innerHTML = 'Map Layers';
    this.layerBtn.appendChild(this.tooltip);
  }

  mouseOut() {
    this.layerBtn.removeChild(this.tooltip);
  }

  setDefaultStyle = () => {
    const prevStyle = document.querySelector('.map-tile-selector.selected');
    if (prevStyle) return prevStyle.innerHTML.toLowerCase();
    return this.currentTour.tourMapStyle;
  };

  toggleStyle(map) {
    const { name } = map.getStyle();
    if (this.currentTour) {
      const { id, mapRenderingUrl } = this.currentTour;
      const newStyle =
        name !== 'Mapbox Satellite Streets'
          ? 'satellite-streets'
          : this.setDefaultStyle();
      mapInterface.updateMapStyle(newStyle, id, mapRenderingUrl);
    } else {
      const newStyle =
        name === 'Mapbox Streets' ? 'satellite-streets' : 'streets';
      mapInterface.updateMapStyle(newStyle);
    }
    this.publicTour && this.sendAnlytics(name);
  }

  sendAnlytics(name) {
    customGaEvent({
      action: GA_EVENTS.MAP_TYPE_SWITCH,
      label: name,
    });
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.container.removeEventListener('click', this.toggleStyle);
    this.container.removeEventListener('mouseenter', this.mouseIn);
    this.container.removeEventListener('mouseleave', this.mouseOut);
    this.map = undefined;
  }
}

export default LayerControls;
